<wl-committee-member-edit-dialog [committeeId]="(route.params | async).id" (saved)="search()"></wl-committee-member-edit-dialog>

<div class="atlas-table">
  <div class="header-bar mb-21 mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-between mct-items-center">
    <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-center mct-gap-10">
      <wl-committee-member-search-actions
        *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }"
        [searchParams]="searchParams"
        [selectAll]="selectAll"
        [selectedItems]="selectedMap"
        [selectedCount]="selectedCount"
        [totalCount]="searchResult?.TotalCount"
        (resultsUpdated)="resultsUpdated()"
      ></wl-committee-member-search-actions>
      <span>
        {{ 'committees.edit.committee-members.there-are' | translate | ucfirst }}
        <strong>{{ selectedCount }} {{ 'committees.edit.committee-members.tagged-profiles' | translate }}</strong>
        {{ 'committees.edit.committee-members.to-take-action-on' | translate }}
      </span>
    </div>
    <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-center mct-gap-10">
      <span *ngIf="!searchResult?.TotalCount; else resultsReturned" class="no-results">
        {{ 'committees.edit.committee-members.no-search-results' | translate | ucfirst }}
      </span>
      <ng-template #resultsReturned>
        <span>
          {{ 'committees.edit.committee-members.the-search-returned' | translate | ucfirst }}
          <strong>{{ searchResult.TotalCount }} {{ 'committees.edit.committee-members.members' | translate }}</strong>
        </span>
      </ng-template>
      <button
        type="button"
        class="atlas-btn atlas-btn-secondary mct-flex mct-row mct-justify-center mct-items-center"
        (click)="clearSearch()"
      >
        <i class="pi pi-times"></i>
        <span>{{ 'committees.edit.committee-members.clear-search' | translate | uppercase }}</span>
      </button>
    </div>
  </div>

  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [loading]="loading"
    [lazy]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="t-ac" [style]="{ width: '55px' }">
          <p-checkbox binary="true" [(ngModel)]="selectAll" (onChange)="onSelectAllChange()"></p-checkbox>
        </th>
        <th pSortableColumn="LastName" class="name-column">
          {{ 'committees.edit.committee-members.name' | translate | ucfirst }}
          <p-sortIcon field="LastName"></p-sortIcon>
        </th>
        <th pSortableColumn="OrgName" class="org-column">
          {{ 'committees.edit.committee-members.representing-organization' | translate | ucfirst }}
          <p-sortIcon field="OrgName"></p-sortIcon>
        </th>
        <th pSortableColumn="Active" class="t-ac active-column">
          {{ 'committees.edit.committee-members.active' | translate | ucfirst }}
          <p-sortIcon field="Active"></p-sortIcon>
        </th>
        <th pSortableColumn="MemberSince" class="start-date-column">
          {{ 'committees.edit.committee-members.start-date' | translate | ucfirst }}
          <p-sortIcon field="MemberSince"></p-sortIcon>
        </th>
        <th pSortableColumn="DateInactive" class="inactive-date-column">
          {{ 'committees.edit.committee-members.inactive-date' | translate | ucfirst }}
          <p-sortIcon field="DateInactive"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-committeeMember>
      <tr>
        <td class="t-ac">
          <p-checkbox
            binary="true"
            [ngModel]="itemIsSelected(committeeMember)"
            (ngModelChange)="onRowSelectionChange(committeeMember)"
          ></p-checkbox>
        </td>
        <td>
          <a [routerLink]="['/profile', committeeMember.ProfileID]">
            {{ committeeMember.FirstName }} {{ committeeMember.LastName }}
            {{ committeeMember.Title ? '(' + committeeMember.Title + ')' : '' }}
          </a>
        </td>
        <td>
          {{ committeeMember.OrgName }}
        </td>
        <td class="t-ac">
          <ng-container
            *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }; else disabled"
          >
            <p-checkbox
              binary="true"
              [(ngModel)]="committeeMember.Active"
              (onChange)="setMemberActive(committeeMember, committeeMember.Active)"
            ></p-checkbox>
          </ng-container>
          <ng-template #disabled>
            <p-checkbox binary="true" [(ngModel)]="committeeMember.Active" disabled></p-checkbox>
          </ng-template>
        </td>
        <td>
          {{ committeeMember.MemberSince | date: 'MM/dd/yyyy' }}
        </td>
        <td>
          <ng-container *ngIf="!committeeMember.Active; else expires">{{ committeeMember.DateInactive | date: 'MM/dd/yyyy' }}</ng-container>
          <ng-template #expires>
            <ng-container *ngIf="committeeMember.TermExpires !== committeeMember.MemberSince">
              {{ committeeMember.TermExpires | date: 'MM/dd/yyyy' }}
            </ng-container>
          </ng-template>
        </td>
        <td class="t-ac">
          <ng-container *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }">
            <action-button
              [label]="'committees.edit.committee-members.actions' | translate | uppercase"
              [items]="actionItemsForMember(committeeMember)"
            >
            </action-button>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="margin-top: -3.3em; float: left">
    <p-select [options]="pagingSizeItems" [(ngModel)]="searchParams.PageSize" (ngModelChange)="pageSizeChanged()" appendTo="body">
    </p-select>
  </div>
  <div style="margin-top: -2.35em; float: right; position: relative">
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary mct-flex mct-row mct-justify-center mct-items-center"
      [disabled]="exporting"
      (click)="exportCommitteeMembers()"
    >
      <i class="pi pi-plus"></i>
      <span>{{ 'committees.edit.committee-members.export-all-members' | translate | uppercase }}</span>
    </button>
  </div>
</div>
